import { createRootRoute, createRoute, createRouter } from '@tanstack/react-router';
import { AppShell } from './components/AppShell';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { AssetsPage } from './pages/AssetsPage';
import { AssetDetailPage } from './pages/AssetDetailPage';
import { CapturePage } from './pages/CapturePage';
import { BulkCapturePage } from './pages/BulkCapturePage';
import { EmployeesPage } from './pages/EmployeesPage';
import { EmployeeDetailPage } from './pages/EmployeeDetailPage';
import { StammdatenPage } from './pages/StammdatenPage';
import { InventoryPage } from './pages/InventoryPage';
import { InventorySessionPage } from './pages/InventorySessionPage';
import { AdminPage } from './pages/AdminPage';
import { ProfilePage } from './pages/ProfilePage';
import { ConfirmPage } from './pages/ConfirmPage';
import { InvitePage } from './pages/InvitePage';

/** Alle Wege durch die Anwendung — bewusst deutsch benannt. */
const rootRoute = createRootRoute({ component: AppShell });

const routes = [
  createRoute({ getParentRoute: () => rootRoute, path: '/', component: DashboardPage }),
  createRoute({ getParentRoute: () => rootRoute, path: '/anmelden', component: LoginPage }),
  createRoute({ getParentRoute: () => rootRoute, path: '/geraete', component: AssetsPage }),
  createRoute({ getParentRoute: () => rootRoute, path: '/erfassen', component: CapturePage }),
  createRoute({
    getParentRoute: () => rootRoute,
    path: '/erfassen/mehrere',
    component: BulkCapturePage,
  }),
  createRoute({
    getParentRoute: () => rootRoute,
    path: '/geraete/$assetId',
    component: AssetDetailPage,
  }),
  // Tiefenlink aus QR-Codes: /assets/97 zeigt dasselbe Gerät wie in Snipe-IT.
  createRoute({
    getParentRoute: () => rootRoute,
    path: '/assets/$assetId',
    component: AssetDetailPage,
  }),
  createRoute({ getParentRoute: () => rootRoute, path: '/personen', component: EmployeesPage }),
  createRoute({
    getParentRoute: () => rootRoute,
    path: '/personen/$employeeId',
    component: EmployeeDetailPage,
  }),
  createRoute({ getParentRoute: () => rootRoute, path: '/stammdaten', component: StammdatenPage }),
  createRoute({ getParentRoute: () => rootRoute, path: '/inventur', component: InventoryPage }),
  createRoute({
    getParentRoute: () => rootRoute,
    path: '/inventur/$sessionId',
    component: InventorySessionPage,
  }),
  createRoute({ getParentRoute: () => rootRoute, path: '/verwaltung', component: AdminPage }),
  createRoute({ getParentRoute: () => rootRoute, path: '/profil', component: ProfilePage }),
  createRoute({
    getParentRoute: () => rootRoute,
    path: '/bestaetigung/$token',
    component: ConfirmPage,
  }),
  createRoute({ getParentRoute: () => rootRoute, path: '/einladung/$token', component: InvitePage }),
];

const routeTree = rootRoute.addChildren(routes);

export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  scrollRestoration: true,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
